import { render, staticRenderFns } from "./file-elem.vue?vue&type=template&id=88f27f24&scoped=true"
import script from "./file-elem.vue?vue&type=script&lang=js"
export * from "./file-elem.vue?vue&type=script&lang=js"
import style0 from "./file-elem.vue?vue&type=style&index=0&id=88f27f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f27f24",
  null
  
)

export default component.exports